<i-title text="Sociétés liées" level="1"></i-title>
<div class="row">
  @if (multiSociete === false) {
    <div class="col-md-12 mb-3">
      <label class="super-compos-label-input">Membre de plusieurs sociétés</label>
      <p-inputSwitch [(ngModel)]="multiSociete" (onChange)="switch(multiSociete)"></p-inputSwitch>
    </div>
  }
</div>
<i-accordion [hideShowAllBtn]="true">
  <i-accordion-tab [(selected)]="activeState[0]" header="Formulaire" [showEditBtn]="false">
    @if (multiSociete === false) {
      <div [formGroup]="membersForm" class="form mb-2">
        <div class="row mb-4">
          <div class="col-md-12 d-flex align-content-center justify-content-end">
            <i-button text="Créer une nouvelle société" (click)="addNew()" styleClass="green" tooltip="Ajouter une nouvelle société"></i-button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <p-dropdown
              [showClear]="true"
              [options]="contactTypes"
              id="contactType"
              placeholder="Sélectionnez un type de contact pour filtrer les expéditeurs"
              [filter]="true"
              styleClass="w-100 dropdown-inforius"
              appendTo="body"
              emptyFilterMessage="Pas de résultats trouvés"
              (onChange)="filterContact($event)">
            </p-dropdown>
          </div>
          <div class="col-md-5">
            @if (contacts.length > 0) {
              <p-dropdown
                [showClear]="true"
                [options]="contacts | sort: 'label' : 'ASC'"
                appendTo="body"
                placeholder="Sélectionnez un contact"
                [filter]="true"
                styleClass="w-100 dropdown-inforius"
                formControlName="societeId"
                name="expediteurId"
                emptyFilterMessage="Pas de résultats trouvés"
                [virtualScroll]="true"
                [virtualScrollItemSize]="31">
              </p-dropdown>
            }
          </div>
          <div class="col-2 d-flex justify-content-end">
            <i-button text="Enregistrer" (click)="addContact()" styleClass="green" tooltip="Ajouter la société sélectionner au contact"></i-button>
          </div>
        </div>
      </div>
    }
    @if (multiSociete === true) {
      <div [formGroup]="multiForm" class="form mb-2">
        <div class="row">
          <div class="col-md-6 mb-3">
            <p-dropdown
              [showClear]="true"
              [options]="contactTypes"
              id="contactType"
              placeholder="Sélectionnez un type de contact pour filtrer les expéditeurs"
              [filter]="true"
              styleClass="w-100 dropdown-inforius"
              emptyFilterMessage="Pas de résultats trouvés"
              (onChange)="filterContact($event)">
            </p-dropdown>
          </div>
          <div class="col-md-6 mb-3">
            @if (contacts.length > 0) {
              <p-dropdown
                [showClear]="true"
                [options]="contacts | sort: 'label' : 'ASC'"
                placeholder="Sélectionnez un contact"
                [filter]="true"
                (onChange)="patchValue($event)"
                styleClass="w-100 dropdown-inforius"
                formControlName="societeId"
                name="expediteurId"
                emptyFilterMessage="Pas de résultats trouvés"
                [virtualScroll]="true"
                [virtualScrollItemSize]="31">
              </p-dropdown>
            }
          </div>
          <div class="col-md-3 mb-3">
            <label class="super-compos-label-input">Relation</label>
            <p-dropdown
              [showClear]="true"
              [options]="typesRelations"
              placeholder="Sélectionnez un type de relation"
              [filter]="true"
              styleClass="w-100 dropdown-inforius"
              formControlName="relationId"
              name="expediteurId"
              emptyFilterMessage="Pas de résultats trouvés"
              [virtualScroll]="true"
              [virtualScrollItemSize]="31">
            </p-dropdown>
          </div>
          <div class="col-md-3 mb-3">
            <label class="super-compos-label-input">Titre</label>
            <i-input
              [iInput]="{ placeholder: 'Titre' }"
              [type]="'text'"
              [control]="multiForm.get('titre')"
              [showError]="false"
              styleClass="d-block w-100"></i-input>
          </div>
          <div class="col-md-3 mb-3">
            <label class="super-compos-label-input">Adresse</label>
            <i-input
              [iInput]="{ placeholder: 'Adresse' }"
              [type]="'text'"
              [control]="multiForm.get('adresse')"
              [showError]="false"
              styleClass="d-block w-100"></i-input>
          </div>
          <div class="col-md-3 mb-3">
            <label class="super-compos-label-input">Code Postal</label>
            <i-input
              [iInput]="{ placeholder: 'Code postal' }"
              [type]="'text'"
              [control]="multiForm.get('codePostal')"
              [showError]="false"
              styleClass="d-block w-100"></i-input>
          </div>
          <div class="col-md-3 mb-3">
            <label class="super-compos-label-input">Localité</label>
            <i-input
              [iInput]="{ placeholder: 'Localité' }"
              [type]="'text'"
              [control]="multiForm.get('localite')"
              [showError]="false"
              styleClass="d-block w-100"></i-input>
          </div>
          <div class="col-md-3 mb-3">
            <label class="super-compos-label-input">Téléphone</label>
            <i-input
              [iInput]="{ placeholder: 'Telephone' }"
              [type]="'text'"
              [control]="multiForm.get('telephone')"
              [showError]="false"
              styleClass="d-block w-100"></i-input>
          </div>
          <div class="col-md-3 mb-3">
            <label class="super-compos-label-input">GSM</label>
            <i-input
              [iInput]="{ placeholder: 'GSM' }"
              [type]="'text'"
              [control]="multiForm.get('gsm')"
              [showError]="false"
              styleClass="d-block w-100"></i-input>
          </div>
          <div class="col-md-3 mb-3">
            <label class="super-compos-label-input">Fax</label>
            <i-input
              [iInput]="{ placeholder: 'FAX' }"
              [type]="'text'"
              [control]="multiForm.get('fax')"
              [showError]="false"
              styleClass="d-block w-100"></i-input>
          </div>
          <div class="col-md-3 mb-3">
            <label class="super-compos-label-input">Email</label>
            <input formControlName="mail" type="mail" class="super-compos-input-text form-control w-100" placeholder="Email" name="mail" />
          </div>
          <div class="col-md-3 mb-3">
            <label class="super-compos-label-input">Site web</label>
            <i-input
              [iInput]="{ placeholder: 'Site web' }"
              [type]="'text'"
              [control]="multiForm.get('site')"
              [showError]="false"
              styleClass="d-block w-100"></i-input>
          </div>
          <div class="col-md-12 d-flex justify-content-center align-content-center">
            @if (update === false) {
              <i-button text="Enregistrer" (click)="addMultiple()" styleClass="green" tooltip="Ajouter la société sélectionner au contact"></i-button>
            }
            @if (update === true) {
              <i-button text="Modifier" (click)="updateLink()" styleClass="green"></i-button>
            }
          </div>
        </div>
      </div>
    }
  </i-accordion-tab>
  <i-accordion-tab [(selected)]="activeState[1]" header="Liste des sociétés liés ({{ linksSoc.length }})" [showEditBtn]="false">
    @if (linksSoc.length > 0) {
      <i-table
        (onClickDelete)="deleteMultiple($event)"
        [paginator]="true"
        class="super-table"
        [columns]="columns"
        height="55vh"
        [items]="linksSoc"
        [multiselect]="true"
        id="societelies"></i-table>
    }
  </i-accordion-tab>
</i-accordion>
